import Vue from "vue";
import Moment from "moment";
import VueI18n from "vue-i18n";
import { Validator } from "vee-validate";

// Load Vue i18n and attach to Vue
Vue.use(VueI18n);

// Load default messages
import messages from "@/lang";

// Loaded langs and defaults
const fallbackLang = "pt-BR";
const defaultLang =
  window.navigator.userLanguage || window.navigator.language || fallbackLang;

// default and builtin lang for: VeeValidate
Moment.locale(fallbackLang);
Validator.localize(fallbackLang, messages[fallbackLang].veevalidate);

/*
 * Create main i18n instance with options
 */
const i18n = new VueI18n({
  locale: defaultLang,
  fallbackLocale: fallbackLang,
  silentTranslationWarn: true,
  messages,
  sync: true,
});

export default i18n;



// WEBPACK FOOTER //
// ./src/services/i18n.js